




























import { Component, Vue } from 'vue-property-decorator';
import '@/styles/MCQ.scss';
import {GeneralService} from '../services/general-service';
import config from '../services/api-config';
import router from '../router';
import store from '../store';

@Component({
  components: {
  }
})

export default class VideosSubject extends Vue {
private service = new GeneralService();
private entities: GActivity[] = []; 
private level_id; 
private isSmart = false;

public selectSubject(id, name){
    this.$store.state.selectSubject = id;
    this.$store.state.selectSubjectName = name;
    if (this.isSmart){
        router.push('videotopic?type=smart')
    } else 
        router.push('videotopic');
}

getImgUrl(pet) {
    if (pet[pet.length - 1] == ' ') {
        pet = pet.substring(0, pet.length-1);
    }
    const images = require.context('@/assets/images/icons/', false, /\.svg$/);
    try{   
        return images('./' + pet + ".svg")
    } catch{
        // return images('./error.png')
    }
}

mounted() {
    this.level_id = localStorage[config.classLevl];

    if (this.$route.query.type && this.$route.query.type == "smart") {
      this.isSmart = true;
    }

    if (this.level_id == '' || this.level_id == undefined || this.level_id == 'null') {
        router.push('select');
    }

    if (this.isSmart){
        this.service.subjects(this.level_id)
            .then(result => { this.entities = result;})
            .catch(err => { console.error(`Error: ${err.message}`); });
    } else {
        this.service.subjects(this.level_id)
            .then(result => { this.entities = result;})
            .catch(err => { console.error(`Error: ${err.message}`); });
    };
    
}
}
